<template lang="html">
  <div class="status-with-note">
    <div class="gap-3x" />
    <div class="question">
      <div class="flex-box product-detail-input">
        <div class="calc-left">
          <div :id="id"></div>
        </div>
        <div class="calc-right">
          <AutoResizeInput
            @update:value="(value) => $emit('update:note', value)"
            :value="note"
            v-if="status=='Available'"
            :error="error"
            :placeholder="placeholder"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AutoResizeInput from 'src/components/common/AutoResizeInput.vue'

let uid = 0

export default {
  components: { AutoResizeInput },
  props: ['status', 'note', 'error', "placeholder"],
  data() {
    return {
      id: '',
      componenId: '',
    }
  },
  methods: {
    updateStatus(value) {
      this.$emit('update:status', value)
    },
  },
  beforeMount() {
    this.id = 'status-with-note-dropdown-' + uid.toString()
    this.componenId = 'status-with-note-' + uid.toString()
    uid += 1
  },
  mounted() {
    window[this.componenId] = this
    // Add dropdown
    this.$nextTick(() => {
      const assetScript = document.createElement('script')
      const defaultValue = this.status === 'Available' ? 1 : 2
      if(!document.querySelector('#' + this.id)) return;

      assetScript.text = `
        new MultiDropdown({
          id: '${this.id}',
          options: [
            { id: "Available", option: "Available" },
            { id: "Unavailable", option: "Unavailable" },
          ],
          selectOption: (value) => window['${this.componenId}'].updateStatus(value.id),
          isMulti: false,
          defaultValueIndex: ${defaultValue},
        });`
      document.head.appendChild(assetScript)
    })
  },
}
</script>

<style lang="scss">
.status-with-note {
  .select-items,
  .selected-item,
  .select-selected {
    width: 100% !important;
    min-width: 150px;
  }
}
</style>

<style lang="scss" scoped>
.status-with-note {
  textarea.textarea {
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.08px;
    width: 100%;
    height: auto;
    resize: none;
    height: 248px;
    border: 1px solid #DCDFFB !important;
    border-radius: 0px;
    padding: 7px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    background-color: transparent;
    outline: none;
  }

  .flex-box {
    align-items: flex-start;
  }

  @media screen and (max-width: 768px) {
    .product-detail-input .calc-left {
      margin-top: 0;
    }
  }
}

</style>
